import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-analyticsloanrepaymentstats',
  templateUrl: './analyticsloanrepaymentstats.component.html',
  styleUrls: ['./analyticsloanrepaymentstats.component.css']
})
export class AnalyticsloanrepaymentstatsComponent implements OnInit {
  @Input('details') details: any;

  constructor(private _location: Location) {
  }

  ngOnInit() {
    //console.log(this.details);
  }
  goBack() {
    this._location.back()
  }
}
